<template>
    <div class="content">
        <!-- 回访信息 -->
        <Drawer
            title="回访信息"
            v-model="showAccessInfo"
            width="720"
            :mask-closable="false"
            :closable="false"
            :styles="styles">
            <Timeline>
                <TimelineItem :color="item.type == '回访记录' ? 'blue' : 'green'" v-for="item in userAccessList"  :key="item.id">
                    <p class="TimelineItemTime">{{item.create_time}}</p>
                    <p class="TimelineItemContent" v-if="item.type == '回访记录'">
                        回访记录：{{item.group}} {{item.come_way }} {{item.return_name}}
                        <span style="color:blue">{{item.content}}</span> 
                        下次回访时间：{{item.visit_time}} {{item.store}} {{item.department}} {{item.user}}
                    </p>
                    <p class="TimelineItemContent" v-if="item.type == '系统记录'">
                        系统记录：{{item.operate_log}}
                        <span style="color:blue">{{item.content}}</span>
                        {{item.store}} {{item.department}} {{item.user}}
                    </p>
                </TimelineItem>
            </Timeline>
            <Divider dashed>没有更多了</Divider>
            <div class="demo-drawer-footer">
                <Button  type="primary" @click="cancel">收起</Button>
            </div>
        </Drawer>
    </div>
</template>
<script>

export default {
    name:'userAccessRecord',
    props:{
        userId:String,
        accessInfoType:String,
        showAccessInfo:Boolean,
        type:String,
    },
    data(){
        return{
            userAccessList:[],
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            }
        }
    },
    created(){
      
    },
    mounted() {
       
    },
    methods:{
        // 客户回访记录  all连锁客户回访 store客户管理回访
        apiUserAccessInfo(id,type){
            let url = this.type == "chainCustomer" ? api.allMemberGetMemberVisits : api.memberGetMemberVisits
            serve.fetchGet(url,{member_id:id,type:type}).then(res => {
                this.userAccessList=res.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 关闭
        cancel(){
            this.$emit('Close',false)
        }
    },
    watch:{
        'showAccessInfo':function (status){
            if(status){
                this.apiUserAccessInfo(this.userId,this.accessInfoType)
            }else{
                this.userAccessList=[]
            }
        }
    }
}
</script>
<style scope>
.mr-t-10{
    margin-top: 10px;
}
.content{

}
.search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
.search_bar_item{
    /* text-align: center; */
    margin: 4px;
  }
.other_search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
 
.table_wrap{
    margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
    margin-left: 4px; 
    padding: 0px !important;
    font-size: 18px!important;
}
.ivu-table-cell {
    white-space: pre-line!important;
}
.ivu-drawer-header-inner {
    font-size: 20px!important;
}
.table_tip{
    height:24px;
    margin: 0 0 10px 0px;
}
.demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
    z-index: 10;
}
.user_info_wrap{
    display: flex;
    justify-content:space-between;
    flex-direction:row;
    flex-wrap: wrap;
    height:40px;
    color: #464c5b;
    font-weight: 600;
    font-size: 14px;
    line-height: 40px;
    background: #f8f8f9;
    margin:10px 0 ;
}
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal  .ivu-modal{
    top: 0;
}
.modal_title{
    text-align: center;
}
.modal_text{
    color:red;
    text-align:center;
    margin-bottom:16px
}
.user_info_text_wrap{
    height: 46px;
    padding-top: 10px;
    padding-left: 32px;
    /* line-height: 56px; */

    /* padding: 10px; */
}
.TimelineItemTime{
    font-size: 14px;
    font-weight: bold;
}
.TimelineItemContent{
    padding-left: 5px;
    font-size: 14px
}
</style>



// WEBPACK FOOTER //
// src/commonTmp/CRM/CustomerManagementTmp/userAccessRecord.vue